export const OVERVIEW_PATH = "overview";
export const FAQ_PATH = "faq";
export const RESOURCES_PATH = "resources";
export const CONTRACTORS_PATH = "contractors";
export const EMPLOYEES_EOR_PATH = "employees-eor";
